import React, { useEffect, useState } from "react";
import { changePage, getBuildings, openBuildingResourceModal } from "../../../../redux/slice/buildingSlice";
import { useDispatch, useSelector } from "react-redux";


import BuildingsTable from "../../../../components/tables/BuildingTable";
import { useLocation } from "react-router-dom";

function AsbestosCertifiedBuildings() {
  const dispatch = useDispatch()
  const location = useLocation()
  const pathName = location?.pathname?.split('/')?.[1]
  console.log(pathName, "path")

  const { currentPage,pageSize } = useSelector((state) => state.building)

  const getBuildingsFunc = async () => {
    dispatch(getBuildings(pathName, "certified"))
  }


  useEffect(() => {
    return () => {
      // Clean up state when component unmounts
      dispatch(changePage({page:1,pageSize}));
    };
  }, []);


  useEffect(() => {
    getBuildingsFunc()
  }, [currentPage,pageSize])
  return (
    <BuildingsTable category={pathName} asbPresent={"unknown"} buildingType={'Certified Buildings'} />
  );
}

export default AsbestosCertifiedBuildings;
